import React from "react";
import styled from "styled-components";
import {device} from "../../assets/styles/media";

const Wrap = styled.h4`
    position: relative;
    margin-bottom: 20px;
    padding-left: 16px;
    color: #30343a;
    font-weight: 800;
    font-size: 24px;

    &::before {
        content: "";
        position: absolute;
        top: 2px;
        left: 0;
        width: 4px;
        height: 28px;
        background: #5233d0;
    }
    ${device.tablet} {
        margin-bottom: 20px;
    }
    
    ${device.mobile} {
        font-size: 16px;
        padding-left: 10px;
        font-weight: 800;
        &::before {
            top: 0;
            width: 2px;
            height: 20px;
        
        }
    }

`;



const SubTitle = ({text}) => {
    return (
        <Wrap>{text}</Wrap>
    );
};

export default SubTitle;
